__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-churn-sense/v4_0_2/";